module.exports = __webpack_public_path__ + "static/faceit-logo-black@2x-5fc691090e579818de4119eb31d5a93c.png";